export const pullToRefresh = 'pull-to-refresh';
export const login = 'login';
